import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Clipboard } from '@angular/cdk/clipboard';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SignInComponent } from '../../../layout/component-layout/sign-in/sign-in.component';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { filter } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { Location } from '@angular/common';
import { AppState } from 'src/app/shareModule/states/app.state';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { MAIN_CATEGORIES } from '../tab-forum.interfaces';

@Component({
  selector: 'app-form-forum',
  templateUrl: './form-forum.component.html',
  styleUrls: ['./form-forum.component.scss'],
})
export class FormForumComponent implements OnInit {
  @ViewChild('forumForm', { static: true }) forumForm: TemplateRef<any>;

  openTag: boolean = false;
  openAll: boolean = false;
  openThreads: boolean = false;
  currentUrl: string = '/forum'
  constructor(
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    public roleSer: RoleService,
    private store: Store<AppState>,
    private commonService: CommonService,
  ) {

  }

  private modalRef: any;
  isLogin: any = 0;
  isLoading: boolean = false;
  appUserId: any;
  categories: any = [];
  darkModeKey: string = 'darkMode';
  forums: any = {
    categoryLoad: false,
    list: {},
    popular: [],
  };

  categoriesSelect: any = [];
  forum: any = {
    categoryId: '',
    titleValue: '',
    messageValue: '',
    categoryValue: '',
    tagValue: 0,
    limitLevelValue: 0,
    hasSubmit: false,
    message: '',
    images: [],
    metadata: ''
  };

  showMessageBoxReply: boolean = false;
  mainCategories = MAIN_CATEGORIES;
  activeMainCategory: string = 'All';
  newPolling: any = {};
  activeIndexPoll: number = 1;
  showFloatingMenu: boolean = false;
  imgUrl: string = environment.ImageUrl;
  activeTab: string = 'Forum';
  menu: boolean = false;
  public isUserDisabled: boolean = false;

  appUserLevel: any = 0;

  ngOnInit() {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.isUserDisabled = user?.isDisabled;
        this.appUserId = user.id;
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });

    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe((res: User) => {
        this.appUserLevel = res.level;
      });

    // document.getElementsByTagName("body")[0].style.setProperty('background-color', 'rgb(105, 44, 189, 0.2)', 'important');

    this.isLoading = true;
    this.initCategories();


    // this.showDetail('forum');
    this.sharedService.initTopic$.subscribe((e: any) => {
      if (e.type == 'topic') this.forumFormModal();
    });
  }

  ngOnDestroy(): void {
    // Clear all intervals
  }

  initForums(slug?: any): void {
    this.sharedService.triggerInitTopic({
      type: 'init',
      slug: slug
    });
  }

  initCategories() {
    this.auth.forum_category_fetch().subscribe((response: any) => {
      this.categories = response.body;
      this.categories.map((row: any) => {
        this.categoriesSelect.push({
          value: row.id.toString(),
          label: row.name,
        });
      });
    });
  }

  handleSelectCategory(categoryId: any = '') {
    if (categoryId == '') this.forums.categoryLoad = false;
    else this.forums.categoryLoad = true;

    if (this.forum.categoryId == categoryId) {
      this.forums.categoryLoad = false;
      this.forum.categoryId = '';
    } else this.forum.categoryId = categoryId;


  }

  forumFormModal(item?: any) {
    const modal = this.forumForm;
    if (!this.appUserId) return this.toastr.error('Please Login First !');
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'md',
      // backdrop: 'static',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'forum_form_modal',
    });

    this.forum = { limitLevelValue: 0, images: [], metadata: '' };
    if (item) {
      this.forum = {
        id: item.id,
        titleValue: item.title,
        messageValue: item.message,
        categoryValue: item.category,
        images: [],
        tagValue: [],
        limitLevelValue: item.limitLevel ?? 0,
        metadata: item.metadata ?? ''
      };

      setTimeout(() => {
        this.forum.tagValue = item.categories.map((row: any) =>
          row.categoryId.toString()
        );
      }, 100);

      if (item.images != null) {
        const images = Array.isArray(item.images)
          ? item.images
          : JSON.parse(item.images ?? '[]');
        this.forum = {
          ...this.forum,
          images: images.map((row: any) => {
            return {
              filePreview: row,
            };
          }),
        };
      }
    }
  }

  onEditorChange = (event: any) =>
    (this.forum.messageValue = event.editor.getData());

  forumStore(id?: number) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    if (this.forum.messageValue.length < 1 && id == null) {
      return this.toastr.error('Please Fill a Message !');
    }

    const form = {
      shopId: 0,
      title: this.forum.titleValue,
      message: this.forum.messageValue,
      category: this.forum.categoryValue,
      categories: this.forum.tagValue,
      limitLevel: this.forum.limitLevelValue,
      metadata: this.forum.metadata,
      createdBy: this.appUserId,
      id: this.forum.id,
      uuid: this.local.generateUUID(),
      images: this.forum.images,
      image: this.forum.images.filter((row) => row.filePreview).map((row) => row.filePreview)
    };


    const formData = new FormData();
    let images = [];
    Object.keys(form).map((row: any) => {
      if (row == 'images') {
        form['images'].map((item: any) => {
          images.push(1);
          formData.append('images', (item.file));
        });
      } else if (row == 'image') {
        form['image'].map((item: any) => {
          if (item.includes('public/'))
            formData.append('image', item);
        });
      } else formData.append(row, form[row]);
    });

    // if (images.length < 1 && this.forum.id == null) {
    //   this.toastr.error('Please Upload at least 1 image!');
    //   return;
    // }


    this.forum.hasSubmit = true;

    this.local.alertLoading({})
    try {
      this.auth.marketplace_forum_shop_store(formData).subscribe(
        (resp: any) => {
          this.forum.hasSubmit = false;
          Swal.fire({
            title: 'Success',
            text: 'The forum was successfully added',
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: 'var(--primary)',
            confirmButtonText: 'OK',
          }).then(() => {
            this.initForums(resp?.body);
            this.modalService.dismissAll();
          });
          this.forum.messageValue = '';
        },
        (e) => {
          Swal.close()
          this.toastr.error(e.error?.message ?? 'Internal Server Error');
          this.forum.hasSubmit = false;
        }
      );
    } catch (e) {
      Swal.close()
      this.forum.hasSubmit = false;
    }
  }

  deletePost(event: any, id: number) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    event.preventDefault();
    Swal.fire({
      title: 'Warning',
      text: 'Are you sure you want to delete the message?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
    }).then((resp: any) => {
      if (resp.isConfirmed) {
        Swal.fire({
          icon: 'info',
          title: 'Please Wait',
          html: 'is deleting messages',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        try {
          this.auth.marketplace_forum_shop_delete(id).subscribe(() => {
            Swal.fire({
              title: 'Success',
              text: 'The message was successfully deleted',
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: 'var(--primary)',
              confirmButtonText: 'OK',
            }).then(() => {
              this.initForums();
            });
          });
        } catch (e) {
          Swal.fire({
            title: 'Error',
            text: 'Internal server error',
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: 'var(--primary)',
            confirmButtonText: 'OK',
          });
        }
      }
    });
  }


  formatDate(value: any) {
    return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
  }


  async handleShowOptionForum(index: number) {
    await Promise.all(
      this.forums?.list.map((row: any, i: number) => {
        if (index != i) row.showOption = false;
        // row.isEdit = false
      })
    ).then(() => {
      this.forums.list[index].showOption = !this.forums.list[index].showOption;
    });
  }
  async handleShowOptionForumReplyChild(item: any) {
    item.showOption = !item.showOption;
  }


  editForumMessage(event: any, item: any) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    event.preventDefault();
    item.isEdit = !item.isEdit;
    item.messageEdit = item.message;
    item.showOption = false;
  }

  editForumMessageReply(event: any, item: any) {
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    event.preventDefault();
    item.isEdit = !item.isEdit;
    item.messageEdit = item.message;
    item.showOption = false;
  }


  handleAddImage() {
    if (this.forum.images.length > 2) {
      return this.toastr.error('Max 3 images');
    }
    this.forum.images = [
      ...this.forum.images,
      {
        filePreview: null,
        file: null,
      },
    ];
  }

  removeImage(i: number) {
    this.forum.images = this.forum.images.filter(
      (row: any, index: number) => index != i
    );
  }

  onImageChange(event: any, data: any) {
    if (event.target.files?.length === 0) {
      return;
    }

    const mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      data.file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (event: any) => {
        data.filePreview = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  handleReport(id: any, category = 'forum') {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitReportMessage({
            message: report.reportDetails,
            type: report.reportType,
            category: category,
            product_id: id,
          })
          .subscribe(
            () => {
              this.toastr.success('Reported successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }

  fileUpload: File | null = null;
  thumbnail: string | null = null;
  onFileSelected(event: any, data: any) {
    this.fileUpload = null;
    this.thumbnail = null;
    const file: File = event.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        data.file = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          data.filePreview = e.target.result;
        };
        reader.readAsDataURL(file);
        this.toastr.success(`Selected image file: ${file.name}`);
      } else {
        this.toastr.warning('Please select an image file');
      }
    } else {
      this.toastr.warning('No file selected');
    }
  }

}
